import { useTranslation } from 'react-i18next'

import NavBarLink from './NavBarLink/Index'
import { RouteAppRequests } from 'routes'

const NavAppRequests = () => {
  const { t } = useTranslation()

  return (
    <NavBarLink name={t('mainHeader.requests')} to={RouteAppRequests()} />
  )
}

export default NavAppRequests
